"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEqualWith = _interopRequireDefault(require("lodash/isEqualWith"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var helpers = _interopRequireWildcard(require("./filter-selector-helpers"));

var _Tooltip = _interopRequireDefault(require("@eig-builder/core-ui/Tooltip"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _Button = _interopRequireDefault(require("@eig-builder/core-ui/Button"));

var _Dialog = _interopRequireDefault(require("@eig-builder/core-ui/Dialog"));

var _DialogActions = _interopRequireDefault(require("@eig-builder/core-ui/DialogActions"));

var _DialogContent = _interopRequireDefault(require("@eig-builder/core-ui/DialogContent"));

var _DialogTitle = _interopRequireDefault(require("@eig-builder/core-ui/DialogTitle"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _IconButton = _interopRequireDefault(require("@eig-builder/core-ui/IconButton"));

var _filterSelectorRenderer = _interopRequireDefault(require("./filter-selector-renderer"));

var _dataGridContext = require("../../../data-grid-context");

var _styles = require("@eig-builder/core-ui/styles");

require("../lang");

/*
  FilterSelector

  This component takes an individual header, like isVisible, and displays two filters for the single
  header, eg. show visible and show non-visible.  This is a requirement of Store.
  The component manages transforming the selection of both, one, or neither of those options into
  a single filter object.  The component also respects filters set by other nav components
  on the data-grid-context.

  Users can supply filters to the component and new selections will call props.setFilters.
  These can be persisent filters fetched from DB and updated by props.setFilters, or simply
  managed on the parent state where FilterSelector is implemented.
 */
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    active: {
      backgroundColor: "rgba(0,0,0,0.08)"
    },
    filterSelector: {
      margin: "0",
      padding: "4px 0",
      listStyle: "none",
      minWidth: "550px",
      "& .filter-selector-container": {
        padding: "4px 0",
        "& .filter-selector-check": {
          padding: "0",
          "float": "left",
          marginTop: "-5px"
        },
        "& .label": {
          cursor: "pointer",
          marginBottom: "0",
          paddingLeft: "8px",
          verticalAlign: "middle"
        }
      }
    },
    filterBtn: {
      display: "inline-block",
      transition: "background-color $short-animation-time ease-in-out",
      "& .icon": {
        color: "$primitive-text-secondary !important",
        verticalAlign: "baseline"
      },
      "&:hover": {
        "& .icon": {
          color: "$primitive-text-primary !important"
        },
        backgroundColor: "$navbar-active-background-color",
        cursor: "pointer"
      }
    }
  };
});

var FilterSelector = function FilterSelector(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      openFilterSelector = _useState2[0],
      setOpenFilterSelector = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      localFilters = _useState4[0],
      setLocalFilters = _useState4[1];

  var _useDataGridContext = (0, _dataGridContext.useDataGridContext)(),
      filterSelectorActive = _useDataGridContext.filterSelectorActive,
      setFilterSelectorActive = _useDataGridContext.setFilterSelectorActive,
      filters = _useDataGridContext.filters,
      setFilters = _useDataGridContext.setFilters,
      filterSelectorHeaders = _useDataGridContext.filterSelectorHeaders,
      setFilterSelectorHeaders = _useDataGridContext.setFilterSelectorHeaders;

  (0, _react.useEffect)(function () {
    updateLocalHeadersFromFilters(filterSelectorHeaders, localFilters);
  }, [localFilters]);
  (0, _react.useEffect)(function () {
    if (Array.isArray(props.filters)) {
      updateLocalFiltersFromPersistentFilters(props.filters);
    }
  }, [props.filters]);
  (0, _react.useEffect)(function () {
    if (!openFilterSelector && !(0, _isEqualWith["default"])(props.headers, filterSelectorHeaders, helpers.isEqualHeaderCustomizer)) {
      setFilterSelectorHeaders(props.headers);
    }
  }, []);

  var updateLocalFiltersFromPersistentFilters = function updateLocalFiltersFromPersistentFilters(persistentFilters) {
    // merge persistent filters with filters created by other data-smp-grid components
    var localFiltersUpdatedWithQueries = helpers.createQueryFiltersFromPersistentFilters(persistentFilters);
    var localAndGlobalFiltersWithQueries = !filters || !filters.length ? localFiltersUpdatedWithQueries : [].concat((0, _toConsumableArray2["default"])(filters.filter(function (f) {
      return f.filterType !== 'filter-selector';
    })), (0, _toConsumableArray2["default"])(localFiltersUpdatedWithQueries));

    if (Array.isArray(localFiltersUpdatedWithQueries) && localFiltersUpdatedWithQueries.length) {
      setFilterSelectorActive(true);
    }

    setFilters(localAndGlobalFiltersWithQueries);
    setLocalFilters(localFiltersUpdatedWithQueries);
  };

  var updateLocalHeadersFromFilters = function updateLocalHeadersFromFilters(headers, filters) {
    // create local headers from filters, or from default
    if (filters && Array.isArray(filters) && filters.length) {
      var newHeaders = helpers.createLocalHeadersFromFilters(headers, filters);
      setFilterSelectorHeaders(newHeaders);
    } else {
      setFilterSelectorHeaders(props.headers.filter(function (h) {
        return h.isFilterable;
      }));
    }
  };

  var filterSelectionClick = function filterSelectionClick(item, filterType) {
    var _helpers$updateHeader = helpers.updateHeadersAndFiltersFromSelection(filterSelectorHeaders, localFilters, item, filterType),
        _helpers$updateHeader2 = (0, _slicedToArray2["default"])(_helpers$updateHeader, 2),
        newHeaders = _helpers$updateHeader2[0],
        newFilters = _helpers$updateHeader2[1];

    setFilterSelectorHeaders(newHeaders);
    setLocalFilters(newFilters);
  };

  var applyFilterSelection = function applyFilterSelection() {
    var boolActive = false; // is filter active?

    filterSelectorHeaders.forEach(function (header) {
      if ([0, 1, 2].includes(header.filterType)) {
        boolActive = true;
      }
    }); // Persist filters.  Don't persist global filters, only those selections made in filter-selector.

    if (props.setFilters && typeof props.setFilters === 'function') {
      props.setFilters(localFilters);
    } // Merge filters from other components with filter-selector selections and set them on context


    if (Array.isArray(filters) && filters.length) {
      setFilters([].concat((0, _toConsumableArray2["default"])(helpers.includeGlobalFilters(filters)), (0, _toConsumableArray2["default"])(localFilters)));
    } else if (!Array.isArray(filters) && filters) {
      setFilters([].concat((0, _toConsumableArray2["default"])(localFilters), [filters]));
    } else {
      setFilters(localFilters);
    } // set open/close and filter icon active


    setFilterSelectorActive(boolActive);
    setOpenFilterSelector(!openFilterSelector);
  };

  var cancelFilterSelection = function cancelFilterSelection() {
    setOpenFilterSelector(!openFilterSelector);
    updateLocalHeadersFromFilters(props.headers, props.filters);
  };

  var filterTag = 'filter-button-' + props.tag;
  var hasFilter = props.hasFilter,
      tooltip = props.tooltip;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    open: openFilterSelector
  }, /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], null, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "core.components.datatable.filter.title"
  })), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, /*#__PURE__*/_react["default"].createElement("ul", {
    className: classes.filterSelector
  }, (0, _filterSelectorRenderer["default"])(filterSelectorHeaders, filterSelectionClick, props.tag))), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "secondary",
    onClick: cancelFilterSelection,
    tag: 'cancel-edit-filters-' + props.tag,
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementLabel: 'cancel-edit-filters' + props.tag,
    dataElementId: 'cancel-edit-filters' + props.tag
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "core.components.datatable.columnSelector.cancelBtn"
  })), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    tag: 'submit-edit-filters-' + props.tag,
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementLabel: 'submit-edit-filters' + props.tag,
    dataElementId: 'submit-edit-filters' + props.tag,
    onClick: applyFilterSelection
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "core.components.datatable.columnSelector.primaryBtn"
  })))), hasFilter && /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: tooltip.text,
    placement: "top",
    className: "".concat(classes.filterBtn, " ").concat(filterSelectorActive ? classes.active : "")
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    onClick: function onClick() {
      setOpenFilterSelector(!openFilterSelector);
    },
    tag: filterTag,
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementLabel: filterTag,
    dataElementId: filterTag
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "tune",
    tag: 'filter-icon-' + props.tag
  })))));
};

var _default = FilterSelector;
exports["default"] = _default;
FilterSelector.propTypes = {
  tag: _propTypes["default"].string,
  hasFilter: _propTypes["default"].bool,
  headers: _propTypes["default"].array.isRequired,
  setFilters: _propTypes["default"].func,
  filters: _propTypes["default"].array,
  tooltip: _propTypes["default"].object
};